<script lang="ts">
  import { fly, fade } from 'svelte/transition';
  import { settings } from '../lib/settings.svelte';
  import { toasts } from '../lib/toasts.svelte';

  const d = $derived(settings.reducedMotion ? 0 : 1);
</script>

<div class="stack" role="status" aria-live="polite">
  {#each toasts.items as t (t.id)}
    <button
      class="toast"
      data-tone={t.tone}
      onclick={() => toasts.dismiss(t.id)}
      in:fly={{ y: 14, duration: 260 * d, opacity: 0 }}
      out:fade={{ duration: 160 * d }}
    >
      {#if t.badge}<span class="badge num">{t.badge}</span>{/if}
      <span class="txt">
        <strong>{t.title}</strong>
        {#if t.body}<span>{t.body}</span>{/if}
      </span>
    </button>
  {/each}
</div>

<style>
  .stack {
    position: fixed;
    z-index: 50;
    /* Bottom of the screen, above the tab bar: the top half belongs to the big number. */
    bottom: calc(env(safe-area-inset-bottom, 0px) + var(--tabbar-h) + 12px);
    left: 50%;
    transform: translateX(-50%);
    width: min(420px, calc(100% - 32px));
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
  }

  @media (min-width: 860px) {
    .stack {
      bottom: var(--space-5);
    }
  }

  .toast {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: var(--space-3);
    width: 100%;
    padding: 10px 14px 10px 10px;
    text-align: left;
    border-radius: 14px;
    background: var(--bg-raised);
    border: 1px solid var(--line);
    box-shadow: 0 10px 30px -12px rgb(0 0 0 / 0.35);
    --tone: var(--accent);
  }
  [data-tone='prime'] {
    --tone: var(--prime);
  }
  [data-tone='twin'] {
    --tone: var(--twin);
  }
  [data-tone='famous'] {
    --tone: var(--famous);
  }
  [data-tone='neutral'] {
    --tone: var(--ink-2);
  }
  [data-tone='danger'] {
    --tone: var(--danger);
  }

  .badge {
    flex: none;
    min-width: 40px;
    height: 40px;
    padding: 0 6px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    font-family: var(--font-num);
    font-weight: var(--num-weight);
    font-size: var(--text-sm);
    color: var(--tone);
    background: color-mix(in srgb, var(--tone) 14%, transparent);
  }

  .txt {
    display: flex;
    flex-direction: column;
    min-width: 0;
    font-size: var(--text-sm);
    line-height: 1.35;
  }
  .txt strong {
    font-weight: 650;
  }
  .txt span {
    color: var(--ink-2);
    font-size: var(--text-xs);
  }
</style>
